import React from 'react'
import { useLocation } from 'react-router-dom'

import { BottomNavigation } from '@/components/BottomNavigation'

interface TabsLayoutProps {
  children: React.ReactNode
}

// Routes that should show bottom navigation
const TAB_ROUTES = [
  '/dashboard',
  '/activity',
  '/stocks',
  '/send-request',
  '/community',
  '/kem-card',
]

// Routes that should NOT show bottom navigation (even if they match TAB_ROUTES)
const EXCLUDED_ROUTES = [
  '/send-request/confirm',
  '/send-request/success',
  '/send-request/recipient-selection',
  '/send-request/recipient',
  '/send-request/with-user',
  '/kem-card/card-info',
  '/kem-card/choose-style',
  '/kem-card/wallet-instructions',
  '/send-request/confirm-multiple',
  '/send-request/success-multiple',
  '/stocks/details',
  '/stocks/buy',
  '/stocks/sell',
  '/stocks/processing-order',
  '/stocks/kyc-pending',
]

// Routes that require a dark background (#171819)
const DARK_BACKGROUND_ROUTES = ['/boxo-miniapp/']

export const TabsLayout: React.FC<TabsLayoutProps> = ({ children }) => {
  const location = useLocation()

  // Check if current route should show bottom navigation
  const shouldShowBottomNav =
    TAB_ROUTES.some(
      (route) =>
        location.pathname === route ||
        location.pathname.startsWith(route + '/'),
    ) &&
    !EXCLUDED_ROUTES.some(
      (excludedRoute) => location.pathname === excludedRoute,
    )

  // Check if current route needs dark background
  const needsDarkBackground = DARK_BACKGROUND_ROUTES.some((route) =>
    location.pathname.startsWith(route),
  )

  // Send-request page handles its own padding to avoid scroll issues
  // const shouldAddPadding =
  // shouldShowBottomNav && location.pathname !== '/send-request'

  // For send-request page, we want the layout to be flex column to accommodate inline navigation
  // const isSendRequestPage = location.pathname === '/send-request'

  return (
    <>
      {/* Main content */}
      <div
        className="h-full"
        style={needsDarkBackground ? { backgroundColor: '#171819' } : undefined}
      >
        {children}
      </div>

      {/* Bottom Navigation */}
      {shouldShowBottomNav && <BottomNavigation />}
    </>
  )
}
